import React from 'react';

import { Tooltip } from '@column/column-ui-kit';
import { Badge } from '@column/ui';

import { getTransferBadgeClassName } from '~/lib/transfers/utils';
import { ACHTransferBatchRecord } from '~/typings/API';

const MESSAGE_LABELS: [prefix: string, label: string][] = [
  ['Account number not found', 'Account not found'],
  ['Bank account does not exist', 'Account not found'],
  ['Invalid account number id', 'Invalid account ID'],
  ['Bank account is frozen', 'Account frozen'],
  ['Invalid value found for alphanumeric field', 'Invalid characters'],
  ['The processing volume exceeded program reserve', 'Reserve exceeded'],
  ['The string value is too long', 'Value too long'],
  ['The request is missing a required parameter', 'Missing field'],
  ['The object is not in a valid status', 'Invalid status'],
  ['Invalid transfer amount', 'Invalid amount'],
  ['Transfer amount exceeds maximum', 'Amount too high'],
  ['Unsupported transfer currency', 'Unsupported currency'],
  ['There is not enough funds', 'Insufficient funds'],
  ['Either bank_account_id or account_number_id', 'Missing account'],
  ['Entry class code is ACH', 'Invalid SEC code'],
  ['Field receiver_id', 'Invalid receiver ID'],
  ['Field receiver_name', 'Invalid receiver name'],
  ['Invalid ACH transfer reversal request', 'Invalid reversal'],
  ['The counterparty account cannot accept ACH', 'Invalid destination'],
  ['You cannot move funds out', 'Debits not allowed'],
  ['ACH debits are not enabled', 'Debits disabled'],
  ['ACH zero-dollar remittance origination is disabled', 'Zero-dollar disabled'],
  ['ACH prenotification (prenote) origination is disabled', 'Prenotes disabled'],
  ['Faster than 2 day ACH debit origination is disabled', 'Fast debits disabled'],
  ['Invalid value for debit settlement delay', 'Invalid settlement delay'],
  ["The originator account's routing number is not enabled", 'Rail not enabled'],
];

const CODE_LABELS: Record<string, string> = {
  bank_account_not_found: 'Account not found',
  bank_account_freeze_not_allowed: 'Account frozen',
  cancellation_not_allowed: 'Not allowed',
  currency_not_supported: 'Unsupported currency',
  feature_not_enabled: 'Feature disabled',
  invalid_field_value: 'Invalid value',
  invalid_originator_account: 'Invalid originator',
  invalid_record_status: 'Invalid status',
  invalid_resource_id_format: 'Invalid ID',
  invalid_string_character: 'Invalid characters',
  limit_exceeded: 'Limit exceeded',
  mandatory_parameter_missing: 'Missing field',
  permission_denied: 'Not permitted',
  transfer_amount_too_high: 'Amount too high',
  transfer_invalid_amount: 'Invalid amount',
  transfer_invalid_destination_account: 'Invalid destination',
  transfer_non_sufficient_fund: 'Insufficient funds',
};

export const getACHBatchRecordErrorLabel = (error: NonNullable<ACHTransferBatchRecord['error']>): string =>
  MESSAGE_LABELS.find(([prefix]) => error.message?.startsWith(prefix))?.[1] ?? CODE_LABELS[error.code] ?? 'Error';

export const ACHBatchRecordErrorBadge: React.FC<{ error?: ACHTransferBatchRecord['error'] | null }> = ({ error }) => {
  if (!error) return null;
  return (
    <Tooltip content={error.message} placement="top" zIndex={100} className="flex">
      <Badge variant="ghost" className={getTransferBadgeClassName('danger')}>
        {getACHBatchRecordErrorLabel(error)}
      </Badge>
    </Tooltip>
  );
};
